module.exports = __webpack_public_path__ + "img/hero@2x.d94e05a2.jpg";